const initializeReskinSelects = require('../util/initialize-reskin-selects');

$(() => {
  const pluginName = 'productsPlugin';
  const dataKey = `plugin_${pluginName}`;

  const classes = {
    hidden: 'hidden',
  };

  let $pluginContainer = null;

  /**
   * Remove generated Select2 markup before cloning or removing a product option.
   *
   * @param $container
   */
  const destroyProductOptionSelects = ($container) => {
    if (typeof $.fn.select2 !== 'function') {
      return;
    }

    $container
      .find('[data-js-product-option-select].select2-hidden-accessible')
      .each((index, element) => $(element).select2('destroy'));
  };

  const Plugin = function Plugin(element) {
    this.element = element;

    // Set the container for the plugin
    $pluginContainer = element;
  };

  /**
   * Show or hide the `Remove` button for the given chosen option container based on a variety of
   * rules, as explained in the comments in the function
   * @param $chosenOptionContainer
   */
  const toggleProductOptionRemoveButton = ($chosenOptionContainer) => {
    const $remove = $chosenOptionContainer.find('[data-js-remove-option]');

    // if there is more than 1 chosen option container for a product, always show the button
    if (!$chosenOptionContainer.is(':only-child')) {
      $remove.removeClass(classes.hidden);
      return;
    }

    // if the add checkbox exists, it means multiple quantities aren't allowed, therefore only 1
    // option can be selected, so hide the button
    if ($chosenOptionContainer.find('.event-registration__add-checkbox').length) {
      $remove.addClass(classes.hidden);
      return;
    }

    const $optionSelect = $chosenOptionContainer.find('[data-js-product-option-select]');

    // it's not possible to select an option, so hide the button
    if (!$optionSelect.length) {
      $remove.addClass(classes.hidden);
      return;
    }

    // the user hasn't selected an option yet, so hide the button
    if (!$optionSelect.val()) {
      $remove.addClass(classes.hidden);
      return;
    }

    $remove.removeClass(classes.hidden);
  };

  /**
   * Go through each chosen option and run the toggle function on them
   * @param $product
   */
  const toggleAllProductOptionRemoveButtons = ($product) => {
    $product
      .find('.event-registration__product-item-chosen-option')
      .each((index, element) => toggleProductOptionRemoveButton($(element)));
  };

  /**
   * Clones the last product option and appends it to the end of the options div, updating IDs and resetting values,
   * required, and errors states
   * @param event
   */
  const addProductOption = (event) => {
    const $product = $(event.currentTarget).closest('.event-registration__product-item');
    const $chosenOptions = $product.find('.event-registration__product-item-chosen-options');
    const $lastOption = $chosenOptions.find('.event-registration__product-item-chosen-option').last();
    destroyProductOptionSelects($lastOption);
    const lastOptionIndex = $lastOption.data('index');
    const $newOption = $chosenOptions.append($lastOption.clone())
      .find('.event-registration__product-item-chosen-option').last();
    const newOptionIndex = parseInt(lastOptionIndex, 10) + 1;
    const newOptionId = $newOption.data('id-prototype').replace('__index__', newOptionIndex);
    const newOptionIdOption = newOptionId.replace('__field__', 'option');
    const newOptionIdQuantity = newOptionId.replace('__field__', 'quantity');
    const newOptionName = $newOption.data('name-prototype').replace('__index__', newOptionIndex);
    const newOptionNameOption = newOptionName.replace('__field__', 'option_id');
    const newOptionNameQuantity = newOptionName.replace('__field__', 'quantity');

    $newOption.data('index', newOptionIndex);

    $newOption.find('[data-js-product-option-label]').attr('for', newOptionIdOption);
    $newOption.find('[data-js-product-quantity-label]').attr('for', newOptionIdQuantity);

    $newOption.find('[data-js-product-option-select]')
      .attr('id', newOptionIdOption).attr('name', newOptionNameOption).attr('required', false)
      .val('')
      .closest('.form-group')
      .removeClass('has-error');

    $newOption.find('[data-js-product-quantity-input]')
      .attr('id', newOptionIdQuantity).attr('name', newOptionNameQuantity).attr('required', false)
      .val('')
      .closest('.form-group')
      .removeClass('has-error');

    initializeReskinSelects(
      $lastOption.add($newOption).find('[data-js-product-option-select]'),
    );
    toggleAllProductOptionRemoveButtons($product);
  };

  /**
   * Removes the product option from the order
   * @param event
   */
  const removeProductOption = (event) => {
    const $option = $(event.currentTarget).closest('.event-registration__product-item-chosen-option');
    const $product = $option.closest('.event-registration__product-item');

    if (!$option.is(':only-child')) {
      destroyProductOptionSelects($option);
      $option.remove();
      toggleAllProductOptionRemoveButtons($product);
      return;
    }

    $option
      .find('[data-js-product-option-select]')
      .val('')
      .trigger('change');
    $option.find('[data-js-product-quantity-input]').val('');

    toggleProductOptionRemoveButton($option);
  };

  /**
   * When the user choose a product option, set the quantity to 1 or clear it when applicable
   * @param event
   */
  const updateProductOption = (event) => {
    const $this = $(event.currentTarget);
    const $option = $this.closest('.event-registration__product-item-chosen-option');
    const $quantity = $option.find('[data-js-product-quantity-input]');

    if ($quantity.length) {
      const minimum = parseInt($quantity.attr('data-minimum'), 10);

      if (minimum) {
        $quantity.attr('min', minimum);
      }

      // If a selection is made, but the quantity is empty or < 1 then set the default quantity
      if (($this.val() || $this.is(':checked')) && ($quantity.val() === '' || parseInt($quantity.val(), 10) < 1)) {
        // Set the quantity to the minimum allowed amount
        $quantity.val(minimum > 0 ? minimum : 1);
      }
    }

    toggleProductOptionRemoveButton($option);
  };

  /**
   * Clear out the min and value of the product option quantity
   * @param event
   */
  const clearProductOption = (event) => {
    const $this = $(event.currentTarget);
    const $option = $this.closest('.event-registration__product-item-chosen-option');
    const $quantity = $option.find('[data-js-product-quantity-input]');

    if ($quantity.length) {
      $quantity.removeAttr('min');
      $quantity.val('');
    }
  };

  /**
   * If the user selects a product option that has a registration discount attached, hide the quantity (but setting
   * it to 1), hide the add option button, and blow out all other selected product options
   * @param event
   */
  const checkRegistrationDiscount = (event) => {
    const $this = $(event.currentTarget);
    const value = $this.val();
    const $item = $this.closest('.event-registration__product-item');
    const $option = $this.closest('.event-registration__product-item-chosen-option');
    const $quantityFormGroup = $option.find('.event-registration__product-quantity-form-group');

    if (!value) {
      $quantityFormGroup.addClass(classes.hidden);
      return;
    }

    const $value = $this.find(`[value="${value}"]`);
    const $addOption = $item.find('[data-js-add-option]');
    const $quantity = $quantityFormGroup.find('[data-js-product-quantity-input]');

    if (typeof $value.data('registration-discount') !== 'undefined') {
      $addOption.addClass(classes.hidden);
      $quantityFormGroup.addClass(classes.hidden);
      $quantity.val(1);
      const $siblingOptions = $option.siblings('.event-registration__product-item-chosen-option');
      destroyProductOptionSelects($siblingOptions);
      $siblingOptions.remove();
      return;
    }

    $addOption.removeClass(classes.hidden);
    $quantityFormGroup.removeClass(classes.hidden);
  };

  /**
   * When the user toggles the single option product on their order, toggle the visibility of the quantity input
   * @param event
   */
  const addSingleProductToOrder = (event) => {
    const $this = $(event.currentTarget);
    const $option = $this.closest('.event-registration__product-item-chosen-option');
    const $quantity = $option.find('.event-registration__product-quantity-form-group');
    const isSelected = $this.is(':checked');

    if ($quantity.length) {
      $quantity.toggleClass(classes.hidden, !isSelected);

      // Trigger the quantity minimum
      if (isSelected) {
        updateProductOption(event);
      } else {
        clearProductOption(event);
      }
    }
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    destroyProductOptionSelects($pluginContainer);
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass(classes.hidden, !isVisible);
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    // sometimes the content already exists in the html, so we can skip this
    if (content) {
      $pluginContainer.html(content);
    }

    $pluginContainer.find('.carousel').carousel();

    $pluginContainer
      .off('click.products', '[data-js-add-option]')
      .on('click.products', '[data-js-add-option]', addProductOption)
      .off('click.products', '[data-js-remove-option]')
      .on('click.products', '[data-js-remove-option]', removeProductOption)
      .off('change.products', '[data-js-product-option-select]')
      .on('change.products', '[data-js-product-option-select]', (event) => {
        updateProductOption(event);
        checkRegistrationDiscount(event);
      })
      .off('change.products', '[data-js-add-to-order]')
      .on('change.products', '[data-js-add-to-order]', addSingleProductToOrder);

    initializeReskinSelects(
      $pluginContainer.find('[data-js-product-option-select]'),
    );
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
